import { Variants } from "framer-motion";

// I think we should not force to generalize these transitions
// If you find I nice way you may implement some generalization, but for now I think its fine
/* jscpd:ignore-start */

export const defaultEase = [0.455, 0.03, 0.515, 0.955];

export const defaultTransition = {
  ease: defaultEase,
  duration: 1,
};

export const y_variant = {
  initial: {
    y: 300,
    opacity: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: defaultTransition,
  },
  exit: {
    y: 300,
    opacity: 0,
    transition: defaultTransition,
  },
};
export const y_variant_small = {
  initial: {
    y: 100,
    opacity: 0,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: defaultTransition,
  },
  exit: {
    y: 100,
    opacity: 0,
    transition: defaultTransition,
  },
};

export const y_variant_small_no_opacity = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: defaultTransition,
  },
  exit: {
    y: "100%",
    transition: defaultTransition,
  },
};

export const negative_y_variant = {
  initial: {
    y: "-100%",
  },
  animate: {
    y: 0,
    transition: defaultTransition,
  },
  exit: {
    y: "-100%",
    transition: defaultTransition,
  },
};

export const full_y_variant = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: defaultTransition,
  },
  exit: {
    y: "100%",
    transition: defaultTransition,
  },
};
export const full_x_variant = {
  initial: {
    x: "100%",
  },
  animate: {
    x: 0,
    transition: defaultTransition,
  },
  exit: {
    x: "100%",
    transition: defaultTransition,
  },
};
export const full_x_negative_variant = {
  initial: {
    x: "-100%",
  },
  animate: {
    x: 0,
    transition: defaultTransition,
  },
  exit: {
    x: "-100%",
    transition: defaultTransition,
  },
};

export const opacity_variant = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      ease: defaultEase,
      duration: 0.8,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: defaultEase,
      duration: 0.8,
    },
  },
};

export const stagger_variant = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const stagger_variant_fast = {
  animate: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

// this is used to pass the animtion state to child (older version of framer)
export const pass_variant = {
  initial: {
    opacity: 1,
  },
  animate: {
    opacity: 1,
  },
};

export const clip_variant = {
  initial: {
    clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
  },
  animate: {
    clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
    transition: { duration: 1, ease: defaultEase },
  },
  exit: {
    clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)",
    transition: { duration: 1, ease: defaultEase },
  },
};

export const width_variant: Variants = {
  initial: {
    width: 0,
  },
  animate: {
    width: "auto",
    transition: defaultTransition,
  },
  exit: {
    width: 0,
    transition: defaultTransition,
  },
};

export const height_variant: Variants = {
  initial: {
    height: 0,
  },
  animate: {
    height: "auto",
    transition: defaultTransition,
  },
  exit: {
    height: 0,
    transition: defaultTransition,
  },
};

export const scale_variant = {
  initial: {
    scale: 0.3,
    opacity: 0,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: defaultTransition,
  },
  exit: {
    scale: 0.3,
    opacity: 0,
    transition: defaultTransition,
  },
};

export const clip_circle_top_variant = {
  initial: {
    clipPath: "circle(0% at 100% 0%)",
  },
  animate: {
    clipPath: "circle(150% at 100% 0%)",

    transition: { duration: 1.5, ease: defaultEase },
  },
  exit: {
    clipPath: "circle(0% at 100% 0%)",
    transition: { duration: 0.8, ease: defaultEase },
  },
};

export const fade_in_right_variant = {
  initial: {
    x: 200,
    opacity: 0,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: defaultTransition,
  },
  exit: {
    opacity: 0,
    x: 0,
    transition: defaultTransition,
  },
};
export const fade_in_left_variant = {
  initial: {
    x: -200,
    opacity: 0,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: defaultTransition,
  },
  exit: {
    opacity: 0,
    x: -200,
    transition: defaultTransition,
  },
};

/* jscpd:ignore-end */
